class MissingEnvError extends Error {
  constructor(key: string) {
    super(`Missing environment value for key: ${key}`);
  }
}

class NoKeyError extends Error {
  constructor() {
    super(`Missing environment key`);
  }
}

export const safeEnv = (key: (typeof process.env)[keyof typeof process.env]) => {
  if (!key) throw new NoKeyError();

  const value = process.env[key];
  if (!value) {
    console.error(`Missing environment value for key: ${key}`);
    throw new MissingEnvError(key);
  }
  return value;
};
